import apiFetch from '../apiFetch'

export default function (processingAgencyId, token) {
  return apiFetch({ endPoint: 'PaymentMethod/' + processingAgencyId + '/Recover', method: 'PUT', body: null, token: token })
}
